export default __webpack_public_path__ + "static/media/picture.612669e1.svg";